import type { FeatureConfig } from '@seek/hirer-feature-toggle';

export const FEATURE_TOGGLE_CART_EDIT_FLOW = 'feature-toggle-cart-edit-flow';
export const FEATURE_TOGGLE_MULTI_LOCATION_FOR_PRODUCT_CODE_SUPPORT =
  'feature-toggle-multi-location-for-product-code-support';
export const EXPERIMENT_CAJA_PRICE_WIDGET_REMOVAL =
  'experiment-caja-price-widget-removal';

export const FEATURE_TOGGLE_RICH_TEXT_EDITOR_CAJA =
  'feature-toggle-rich-text-editor-caja';

export const FEATURE_TOGGLE_AI_AD_WRITING_V2 =
  'feature-toggle-ai-ad-writing-v-2';

export const features: FeatureConfig[] = [
  {
    key: FEATURE_TOGGLE_CART_EDIT_FLOW,
    name: 'Cart edit flow',
    description: 'Cart edit flow feature toggle',
    variants: [true, false],
    fallback: false,
  },
  {
    key: FEATURE_TOGGLE_RICH_TEXT_EDITOR_CAJA,
    name: 'Rich text editor CAJA',
    description: 'New rich text editor in CAJA',
    variants: [true, false],
    fallback: false,
  },
  {
    key: FEATURE_TOGGLE_MULTI_LOCATION_FOR_PRODUCT_CODE_SUPPORT,
    name: 'Multi location for product code support',
    description: 'Multi location for product code support feature toggle',
    variants: [true, false],
    fallback: false,
  },
  {
    key: EXPERIMENT_CAJA_PRICE_WIDGET_REMOVAL,
    name: 'Price checker experiment toggle',
    description: 'Price Panel will not be shown when this feature is turned on',
    variants: ['control', 'test'],
    fallback: 'control', // The price panel will not be shown on Classify page for variant `test`
  },
  {
    key: FEATURE_TOGGLE_AI_AD_WRITING_V2,
    name: 'AI ad writing v2',
    description: 'AI ad writing v2 feature toggle',
    variants: [true, false],
    fallback: false,
  },
];
